import { Lookup, LookupKeys } from '../../../models/crm/lookup.model';

export enum ReportIds {
  mgaPaid = 'mga_paid',
  personalPaid = 'personal_paid',
  rmdPaid = 'rmd_paid',
  mgaSubmit = 'mga_submit',
  personalSubmit = 'personal_submit',
  rmdSubmit = 'rmd_submit',
}

export type ReportId = `${ReportIds}`;

export enum ReportInputParameterTypes {
  date = 'date',
  number = 'number',
  boolean = 'boolean',
  select = 'select',
}

export type ReportInputParameterType = `${ReportInputParameterTypes}`;

export enum ReportInputParameterKeys {
  startDate = 'start_date',
  endDate = 'end_date',
  displayThreshold = 'display_threshold',
  includeThreshold = 'include_threshold',
  ntpDisplayMode = 'ntp_display_mode',
  showSuppressedAgents = 'show_suppressed_agents',
  showTotals = 'show_totals',
  /** @deprecated Legacy Reporting API compatibility only. */
  showNtpSeparately = 'show_ntp_separately',
  /** @deprecated Legacy Reporting API compatibility only. */
  hideSuppressedAgents = 'hide_suppressed_agents',
}

export enum ReportNtpDisplayModes {
  hide = 'hide',
  separate = 'separate',
  generalList = 'general_list',
}

export type ReportNtpDisplayMode = `${ReportNtpDisplayModes}`;

export enum ReportBrandingIds {
  allianceGroup = 'alliance_group',
  fiveRingsFinancial = 'five_rings_financial',
  livingBenefitSolutions = 'living_benefit_solutions',
}

export type ReportBrandingId = `${ReportBrandingIds}`;

export {
  ALLIANCE_GROUP_SUBTITLE,
  FIVE_RINGS_FINANCIAL_SUBTITLE,
  LIVING_BENEFIT_SOLUTIONS_SUBTITLE,
} from '../branding-subtitles';
import {
  ALLIANCE_GROUP_SUBTITLE,
  FIVE_RINGS_FINANCIAL_SUBTITLE,
  LIVING_BENEFIT_SOLUTIONS_SUBTITLE,
} from '../branding-subtitles';

export const BrandingLookup: Partial<Lookup>[] = [
  {
    [LookupKeys.value]: ReportBrandingIds.allianceGroup,
    [LookupKeys.description]: ALLIANCE_GROUP_SUBTITLE,
  },
  {
    [LookupKeys.value]: ReportBrandingIds.fiveRingsFinancial,
    [LookupKeys.description]: FIVE_RINGS_FINANCIAL_SUBTITLE,
  },
  {
    [LookupKeys.value]: ReportBrandingIds.livingBenefitSolutions,
    [LookupKeys.description]: LIVING_BENEFIT_SOLUTIONS_SUBTITLE,
  },
];

export interface ReportInputParameter {
  key: ReportInputParameterKeys;
  type: ReportInputParameterType;
  required: boolean;
}
